import React from 'react'
import Button from '../../Button/Button'
import ViewAllChoicesTrigger from './ViewAllChoicesTrigger'
import { Choice, SELECT_FIELD_INLINE_CHOICE_LIMIT } from './selectFieldHelpers'

interface SelectInlineFooterProps {
  fieldUid: string
  choices: Choice[]
  isKeyValue: boolean
  isMultiple: boolean
  currentValue: string | string[] | null
  isReadOnly?: boolean
  hasValue: boolean
  title?: string
  onApply: (newValue: string | string[] | null) => void
  onClear: () => void
}

/**
 * Footer row under an inline RADIO/CHECKBOX list (Figma: "View All ({N}) Choices"
 * + "Clear Selection", left-aligned). "View All" only appears once the choice
 * count exceeds the inline limit; "Clear Selection" replaces the old RADIO "None"
 * option and is disabled when nothing is selected.
 */
const SelectInlineFooter: React.FC<SelectInlineFooterProps> = ({
  fieldUid,
  choices,
  isKeyValue,
  isMultiple,
  currentValue,
  isReadOnly,
  hasValue,
  title,
  onApply,
  onClear
}) => {
  if (isReadOnly) return null
  const overLimit = choices.length > SELECT_FIELD_INLINE_CHOICE_LIMIT
  // Nothing to offer: no "View All" needed and nothing to clear.
  if (!overLimit && !hasValue) return null

  return (
    <div className="sf-inline-footer" data-test-id={`cs-asset-details-field-${fieldUid}-inline-footer`}>
      {overLimit ? (
        <ViewAllChoicesTrigger
          fieldUid={fieldUid}
          choices={choices}
          isKeyValue={isKeyValue}
          isMultiple={isMultiple}
          currentValue={currentValue}
          isReadOnly={isReadOnly}
          title={title}
          onApply={onApply}
        />
      ) : null}
      <Button
        version="v2"
        buttonType="tertiary"
        size="small"
        disabled={!hasValue}
        onClick={onClear}
        testId={`cs-asset-details-field-${fieldUid}-clear-selection`}
      >
        Clear Selection
      </Button>
    </div>
  )
}

export default SelectInlineFooter
